(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.RealmProtectionGate=api;})(typeof window==='undefined'?globalThis:window,function(){
  'use strict';
  const id = value => /^[1-9]\d*$/.test(String(value || '')) ? String(value) : null;
  function protectionLines(cart, config) {
    if (!id(config?.product_id) || config.handle !== 'shipping-protection') throw failure('identity-unavailable','identity');
    return (cart?.items || []).filter(line => id(line.product_id) === id(config.product_id));
  }
  function merchandiseSignature(cart, config) {
    const fees=protectionLines(cart,config),protection=new Set(fees.map(line=>line.key));
    if(fees.length>1||fees.some(line=>line.quantity!==1))throw failure('fee-shape','cart');
    const stable=value=>Array.isArray(value)?value.map(stable):value&&typeof value==='object'?Object.fromEntries(Object.keys(value).sort().map(key=>[key,stable(value[key])])):value===undefined?null:value;
    const subtract=(field,lineField)=>{
      if(!Number.isSafeInteger(cart[field])||cart[field]<0||fees.some(line=>!Number.isSafeInteger(line[lineField])||line[lineField]<0))throw failure('money-invalid','cart');
      const amount=cart[field]-fees.reduce((sum,line)=>sum+line[lineField],0);if(!Number.isSafeInteger(amount)||amount<0)throw failure('money-invalid','cart');return amount;
    };
    const feeDiscount=fees.reduce((sum,line)=>sum+line.original_line_price-line.final_line_price,0);
    if(!Number.isSafeInteger(cart.total_discount)||!Number.isSafeInteger(feeDiscount)||feeDiscount<0||cart.total_discount<feeDiscount)throw failure('discount-invalid','cart');
    if(cart.original_total_price-cart.total_price!==cart.total_discount||cart.total_price>cart.items_subtotal_price||cart.items_subtotal_price>cart.original_total_price)throw failure('totals-invalid','cart');
    const fields=['currency','taxes_included','note','attributes','cart_level_discount_applications','discount_codes'];
    const lineFields=['key','variant_id','id','quantity','properties','selling_plan_allocation','price','original_price','discounted_price','final_price','line_price','original_line_price','final_line_price','total_discount','line_level_total_discount','discounts','discount_allocations','line_level_discount_allocations'];
    const allocations=value=>Array.isArray(value)?value.map(allocation=>{
      if(!allocation||typeof allocation!=='object'||Array.isArray(allocation))return allocation;
      const application=allocation.discount_application;
      if(!application||typeof application!=='object'||Array.isArray(application))return allocation;
      // Shopify regenerates these application metadata fields when the provider
      // changes its fee. Retain every amount, commercial term and unknown field.
      const {key,created_at,...terms}=application;
      return {...allocation,discount_application:terms};
    }):value;
    return JSON.stringify(stable({
      ...Object.fromEntries(fields.map(key=>[key,cart[key]])),
      item_count:subtract('item_count','quantity'),
      total_price:subtract('total_price','final_line_price'),
      original_total_price:subtract('original_total_price','original_line_price'),
      items_subtotal_price:subtract('items_subtotal_price','final_line_price'),
      total_discount:cart.total_discount-feeDiscount,
      items:cart.items.filter(line=>!protection.has(line.key)).map(line=>Object.fromEntries(lineFields.map(key=>[key,key==='line_level_discount_allocations'?allocations(line[key]):line[key]]))).sort((a,b)=>String(a.key).localeCompare(String(b.key)))
    }));
  }
  const failure = (reason='cart-invalid',stage='cart') => Object.assign(new Error('Shipping protection could not be verified. Retry before checkout.'), { checkoutReason:'protectionPending',protectionReason:reason,protectionStage:stage });
  class ProtectionGate {
    constructor(config, service, readChoice, readProviderBusy = () => false) { this.config=config;this.service=service;this.readChoice=readChoice;this.readProviderBusy=readProviderBusy;this.generation=0;this.choice=null;this.pendingIntent=false;this.choiceSource='observed'; }
    intent(next,{source='trusted'}={}) {
      if(typeof next!=='boolean')throw failure('choice-invalid','intent');
      this.generation++;this.choice=next;this.pendingIntent=true;
      if(source==='trusted')this.choiceSource='trusted';
      else if(this.choiceSource!=='trusted')this.choiceSource=source;
    }
    settle() { const actual=this.readChoice();if(actual !== this.choice) throw failure('choice-mismatch','settle');this.pendingIntent=false; }
    snapshot() {
      if(this.readProviderBusy() !== false)throw failure('provider-busy','snapshot');
      const actual=this.readChoice();
      if(this.pendingIntent && actual === this.choice) this.pendingIntent=false;
      if(this.pendingIntent)throw failure('intent-pending','snapshot');
      if(actual !== null && this.choice !== null && actual !== this.choice)throw failure('choice-mismatch','snapshot');
      if(this.choice === null) this.choice=actual;
      return this.generation;
    }
    isOff(generation) { return this.generation===generation&&this.choice===false; }
    assert(generation,cart) {
      if(this.readProviderBusy() !== false)throw failure('provider-busy','assert');
      if(generation!==this.generation)throw failure('generation-changed','assert');
      if(this.pendingIntent)throw failure('intent-pending','assert');
      const actual=this.readChoice();if(actual!==null && actual!==this.choice)throw failure('choice-mismatch','assert');
      const lines=protectionLines(cart,this.config);
      if(this.choice===false && lines.length || this.choice===true && (lines.length!==1||lines[0].quantity!==1) || this.choice===null && lines.length)throw failure('fee-choice-mismatch','assert');
    }
    merchandiseSignature(cart){return merchandiseSignature(cart,this.config);}
    async waitForProvider({review=false,assertActive=()=>{}}={}) {
      const generation=this.generation,deadline=Date.now()+1500;
      // The provider can intercept the same Checkout click before native submit.
      // Wait at most 1.5 seconds for that exact choice; a newer intent needs review.
      for(let attempt=0;attempt<=30;attempt++) {
        assertActive();
        if(generation!==this.generation)throw failure('generation-changed','provider-wait');
        const actual=this.readChoice();
        if(this.readProviderBusy()===false&&(review||!this.pendingIntent||actual===this.choice))return review?generation:this.snapshot();
        if(attempt===30||Date.now()>=deadline)throw failure(this.readProviderBusy()!==false?'provider-busy':'intent-pending','provider-wait');
        await new Promise(resolve=>setTimeout(resolve,Math.min(50,deadline-Date.now())));
      }
    }
    async recover({assertActive=()=>{}}={}) {
      // Only an explicit shopper Retry may review a stale saved preference.
      // A current trusted choice is never changed here, and this method never
      // clicks provider controls or creates a new ON consent.
      const generation=await this.waitForProvider({review:true,assertActive});
      assertActive();
      if(this.service.pending||this.service.recovery)throw failure('cart-busy','recover');
      if(generation!==this.generation)throw failure('generation-changed','recover');
      const actual=this.readChoice();
      if(actual===null&&this.choice!==null)throw failure('widget-missing','recover');
      if(actual!==this.choice){
        if(this.choiceSource==='restored'&&this.choice===true&&actual===false){
          this.generation++;this.choice=false;this.choiceSource='reviewed-off';
        } else if(this.choice===null&&typeof actual==='boolean')this.choice=actual;
        else throw failure('choice-mismatch','recover');
      }
      this.pendingIntent=false;
      return this.reconcile({assertActive});
    }
    async reconcile({assertActive=()=>{}}={}) {
      const generation=await this.waitForProvider({assertActive});
      const assertCurrent=()=>{assertActive();if(generation!==this.generation)throw failure('generation-changed','reconcile');};
      assertCurrent();
      await this.service.refresh();
      assertCurrent();
      if(this.choice===false) {
        const before=this.merchandiseSignature(this.service.cart);
        const fees=protectionLines(this.service.cart,this.config);
        // Only current keys of the configured provider product may be removed.
        for(const line of fees) {
          const assertRemoval=()=>{
            assertActive();
            if(generation!==this.generation)throw failure('generation-changed','fee-remove');
            if(this.readProviderBusy()!==false)throw failure('provider-busy','fee-remove');
            if(this.readChoice()!==false)throw failure('choice-mismatch','fee-remove');
          };
          assertRemoval();
          try { await this.service.mutate({kind:'change',key:line.key,quantity:0},{assertActive:assertRemoval});assertCurrent(); }
          catch(error) {
            // An ambiguous response is resolved by readback, never a blind replay.
            assertCurrent();
            await this.service.refresh();
            assertCurrent();
            if(protectionLines(this.service.cart,this.config).some(item=>item.key===line.key))throw failure('fee-remove-unconfirmed','fee-remove');
            if(this.service.recovery) { this.service.recovery=null;this.service.state({phase:'refreshed'}); }
          }
        }
        if(fees.length){await this.service.refresh();assertCurrent();}
        if(before!==this.merchandiseSignature(this.service.cart))throw failure('merchandise-changed','reconcile');
      }
      assertCurrent();this.assert(generation,this.service.cart);return generation;
    }
  }
  function mount(document,window,config,service) {
    if(config?.enabled!==true)return null;
    const selector='[data-shipcheck-extension="true"] .asc-widget-switch[role="switch"]';
    const readChoice=()=>{
      const switches=Array.from(document.querySelectorAll(selector)).filter(node=>node.isConnected!==false);
      if(!switches.length)return null;
      const choices=switches.map(node=>node.getAttribute('aria-checked'));
      if(choices.some(value=>!['true','false'].includes(value)))throw failure('widget-invalid','widget');
      if(new Set(choices).size!==1)throw failure('widget-conflict','widget');
      return choices[0]==='true';
    };
    const providerControls=new Set();
    const checkoutSelector='[data-realm-checkout-form] .realm-checkout[name="checkout"]';
    const readProviderBusy=()=>{
      for(const control of document.querySelectorAll(checkoutSelector+'[data-asc-loading]'))providerControls.add(control);
      let busy=false;
      for(const control of providerControls){
        if(control.hasAttribute('data-asc-loading'))busy=true;
        else providerControls.delete(control);
      }
      return busy;
    };
    const gate=new ProtectionGate(config,service,readChoice,readProviderBusy);
    const preferenceProductId=id(config.product_id);
    const preferenceKey='realm:protection-choice:v1:'+preferenceProductId;
    const preferenceLifetime=30*60*1000;
    const readPreference=()=>{
      if(!preferenceProductId||config.handle!=='shipping-protection')return null;
      try {
        const value=JSON.parse(window.sessionStorage.getItem(preferenceKey));
        const now=Date.now();
        if(value?.version===1&&value.origin===window.location.origin&&value.productId===preferenceProductId&&value.handle===config.handle&&typeof value.choice==='boolean'&&Number.isSafeInteger(value.recordedAt)&&value.recordedAt<=now&&now-value.recordedAt<preferenceLifetime)return value;
        window.sessionStorage.removeItem(preferenceKey);
      } catch(_) {try{window.sessionStorage.removeItem(preferenceKey);}catch(_){}}
      return null;
    };
    const writePreference=choice=>{
      if(!preferenceProductId||config.handle!=='shipping-protection')return null;
      const value={version:1,origin:window.location.origin,productId:preferenceProductId,handle:config.handle,choice,recordedAt:Date.now()};
      try {window.sessionStorage.setItem(preferenceKey,JSON.stringify(value));return value;}catch(_){return null;}
    };
    let preference=readPreference(),restoringControl=null,recovering=false,restorationAttempted=false,restorationDeadline=0,restorationTimer=null,restoredGeneration=null,reconciledGeneration=null;
    const reconcile=gate.reconcile.bind(gate);
    gate.reconcile=async options=>{const generation=await reconcile(options);reconciledGeneration=generation;return generation;};
    const recover=gate.recover.bind(gate);
    gate.recover=async options=>{
      // A pending page-load restoration must not run after the shopper has
      // explicitly reviewed the current cart with Retry.
      if(restorationTimer!==null)window.clearTimeout(restorationTimer);
      restorationTimer=null;restorationAttempted=true;recovering=true;
      try {
        const generation=await recover(options);
        reconciledGeneration=generation;restoredGeneration=generation;
        if(typeof gate.choice==='boolean')preference=writePreference(gate.choice);
        return generation;
      } finally {recovering=false;}
    };
    const restorePreference=()=>{
      restorationTimer=null;
      if(recovering||!preference||restorationAttempted||Date.now()>restorationDeadline)return;
      const saved=readPreference();
      if(!saved||saved.recordedAt!==preference.recordedAt||saved.choice!==preference.choice)return;
      try {
        const actual=readChoice();
        if(readProviderBusy()!==false||service.pending||service.recovery)throw failure();
        if(actual===preference.choice){gate.settle();return;}
        const controls=Array.from(document.querySelectorAll(selector)).filter(node=>node.isConnected!==false);
        if(actual===null||controls.length!==1)throw failure();
        const control=controls[0];
        if(control.disabled||control.hasAttribute('disabled')||control.getAttribute('aria-disabled')==='true'||control.getAttribute('aria-busy')==='true'||typeof control.click!=='function')throw failure();
        restorationAttempted=true;
        restoringControl=control;
        try {control.click();restoredGeneration=gate.generation;}finally{restoringControl=null;}
      } catch(_) {
        if(!restorationAttempted&&Date.now()<restorationDeadline)restorationTimer=window.setTimeout(restorePreference,50);
      }
    };
    const scheduleRestoration=()=>{
      if(recovering||!preference||restorationAttempted||restorationTimer!==null||Date.now()<preference.recordedAt||Date.now()-preference.recordedAt>=preferenceLifetime)return;
      if(restorationDeadline===0){
        if(!Array.from(document.querySelectorAll(selector)).some(node=>node.isConnected!==false))return;
        restorationDeadline=Date.now()+10000;
      }
      if(Date.now()<=restorationDeadline)restorationTimer=window.setTimeout(restorePreference,50);
    };
    const beginRestoration=event=>{
      const saved=readPreference();
      if(!saved)return;
      preference=saved;
      if(gate.choice===null)gate.intent(saved.choice,{source:'restored'});
      if(gate.choice!==saved.choice)return;
      if(event?.isTrusted===true&&event.persisted===true&&restorationAttempted&&restoredGeneration===gate.generation&&reconciledGeneration===gate.generation&&!gate.pendingIntent){restorationAttempted=false;restoredGeneration=null;reconciledGeneration=null;}
      restorationDeadline=0;
      scheduleRestoration();
    };
    // Window capture precedes the provider's document capture listener. Retain
    // its genuine loading control even if a cart refresh detaches that button.
    window.addEventListener('click',event=>{
      const control=event.target.closest?.(checkoutSelector);if(!control)return;
      providerControls.add(control);
      window.queueMicrotask(()=>{if(!control.hasAttribute('data-asc-loading'))providerControls.delete(control);});
    },true);
    document.addEventListener('click',event=>{
      const control=event.target.closest?.(selector);if(!control||event.isTrusted!==true&&restoringControl!==control)return;
      const next=control.getAttribute('aria-checked')!=='true';
      gate.intent(next,{source:event.isTrusted===true?'trusted':'restored'});
      if(event.isTrusted===true){
        preference=writePreference(next);
        restorationAttempted=false;
        restoredGeneration=null;reconciledGeneration=null;
        restorationDeadline=Date.now()+10000;
      }
      // Let the installed provider handle its genuine choice, then verify it.
      window.queueMicrotask(()=>{try{gate.settle();}catch(_){gate.pendingIntent=true;}scheduleRestoration();});
    },true);
    if(typeof window.MutationObserver==='function'){
      const observer=new window.MutationObserver(scheduleRestoration);
      observer.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-checked','aria-busy','aria-disabled','disabled','data-asc-loading']});
    }
    window.addEventListener('pageshow',beginRestoration);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',beginRestoration,{once:true});
    else beginRestoration();
    return gate;
  }
  return {protectionLines,merchandiseSignature,ProtectionGate,mount};
});
